import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema, setInModel } from 'i2g-ng-utils';
import { FeedInfo } from './feed-info.model';

export const MESSAGE_FEED = Object.freeze({
  FEED_INFO: FeedInfo,
  ROLE: '',
  TYPE: '',
});
export const RECORD = generateSchema(MESSAGE_FEED);
export const KEYS: any = generateKeys(MESSAGE_FEED);

export class MessageFeed extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.FEED_INFO,
        value: props.get(KEYS.FEED_INFO) ? new FeedInfo(this.feedInfo) : null,
      },
    ]);

    return selfModel as MessageFeed;
  }

  get feedInfo(): FeedInfo {
    return this.get(KEYS.FEED_INFO);
  }

  get role(): string {
    return this.get(KEYS.ROLE);
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }
}
